import { imageToFile as m } from "@systemeio/file-manager";
import { ImageNameEnum as s } from "../image-enum.mjs";
const l = (t) => t.type.name === s.Block || t.type.name === s.Inline, d = (t) => {
  var r;
  return l(t) && !!((r = t.attrs) != null && r.src) && !t.attrs.uploadingProps;
}, i = (t) => {
  var e;
  return ((e = t.split("/").pop()) == null ? void 0 : e.split("?")[0]) || "image";
}, c = (t, r) => {
  if (/\.\w+$/.test(t)) return t;
  const e = r.split("/")[1] || "png";
  return `${t}.${e}`;
}, p = (t) => t.startsWith("file:///"), f = (t, r) => {
  t.state.doc.descendants((e, n) => {
    var a;
    return l(e) && ((a = e.attrs.uploadingProps) == null ? void 0 : a.id) === r ? (t.dispatch(t.state.tr.delete(n, n + e.nodeSize).setMeta("addToHistory", !1)), !1) : !0;
  });
}, y = async (t) => {
  if (p(t))
    return null;
  const r = "image/png";
  try {
    const e = await fetch(t);
    if (!e.ok) throw new Error("Failed to fetch image");
    const n = await e.blob(), a = n.type || r, o = c(i(t), a);
    return new File([n], o, { type: a });
  } catch {
    try {
      const e = new Image();
      e.crossOrigin = "anonymous", await new Promise((a, o) => {
        e.onload = a, e.onerror = o, e.src = t;
      });
      const n = c(i(t), r);
      return await m(e, n, r);
    } catch {
      return null;
    }
  }
};
export {
  c as ensureExtension,
  i as getFileNameFromUrl,
  l as isImageNode,
  p as isLocalFileUrl,
  d as isValidUploadedImage,
  y as loadImageFromUrl,
  f as removeUploadingImage
};
